import React from "react";
import {Button, Modal} from "react-bootstrap";
import ModalControls from "./ModalControls";
import "../../../css/DictionaryForms.css";

const SettingsEntityModal = ({
  show,
  onClose,
  title,
  adding,
  introText,
  onRestore,
  onDelete,
  onSubmit,
  state,
  size = "lg",
  children
}) => {
  const sizeClass = size === "sm"
    ? "dictionary-form-modal-dialog-sm"
    : size === "xl"
      ? "settings-form-modal-dialog-xl"
      : "";

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      className="dictionary-form-modal settings-form-modal"
      dialogClassName={`dictionary-form-modal-dialog settings-form-modal-dialog ${sizeClass}`}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="dictionary-form-intro">
          <div>
            <strong>{adding ? "Dodajesz nową pozycję" : "Edytujesz istniejącą pozycję"}</strong>
            <span>{introText}</span>
          </div>
          {!adding && onRestore && (
            <Button size="sm" variant="outline-secondary" onClick={onRestore}>
              Przywróć wartości
            </Button>
          )}
        </div>

        {children}
      </Modal.Body>

      <ModalControls
        onDelete={onDelete}
        onCloseDetails={onClose}
        onSubmit={onSubmit}
        state={state}
      />
    </Modal>
  );
};

export default SettingsEntityModal;

